/* eslint-disable */
import axios from "axios";
import _ from "lodash";

import SceneOpening from "./SceneOpening";
import SceneAchievement from "./SceneAchievement";
import ScenePlay from "./ScenePlay";

class GameMain {
  constructor() {
    this.canvas;
    this.engine;

    this.sceneOpening;
    this.sceneAchievement;
    this.scenePlay;

    this.sceneLoaded = 0;
    this.sceneLoadMax = 3;
    this.sceneLoadComplete;

    //設定項目
    this.purpose = "Message";
    this.place;
    this.member = 0;
    this.date = new Date(2019, 11, 31);
    this.distance = 0;
  }

  //------------------------------------
  // Initialize
  //------------------------------------
  init(sceneLoadComplete) {
    if (BABYLON.Engine.isSupported()) {
      //Initialize Babylon.js base engine
      this.canvas = document.getElementById("renderCanvas");
      this.engine = new BABYLON.Engine(this.canvas, true, {
        preserveDrawingBuffer: true,
        stencil: true
      });
      this.engine.setHardwareScalingLevel(1);

      //Initialize Scene
      this.sceneLoadComplete = sceneLoadComplete;

      this.sceneOpening = new SceneOpening(this.engine);
      this.sceneOpening.init("opening.gltf").then(scene => {
        this.sceneOpening.setup();
        this.onSceneLoadComplete();
      });

      this.sceneAchievement = new SceneAchievement(this.engine);
      this.sceneAchievement.init("achievement.gltf").then(scene => {
        this.sceneAchievement.setup();
        this.onSceneLoadComplete();
      });

      this.scenePlay = new ScenePlay(this.engine);
      this.scenePlay.init("achievement.gltf").then(scene => {
        this.scenePlay.setup();
        this.onSceneLoadComplete();
      });

      //Resize Window
      window.onresize = () => {
        this.resize();
      };

      this.resize();
    }
  }

  getSceneLoadStatus() {
    let sceneOpeningLoadStatus = this.sceneOpening.getLoadStatus();
    let sceneAchievementLoadStatus = this.sceneAchievement.getLoadStatus();
    let scenePlayLoadStatus = this.scenePlay.getLoadStatus();

    let loaded =
      sceneOpeningLoadStatus.loaded +
      sceneAchievementLoadStatus.loaded +
      scenePlayLoadStatus.loaded;

    let loadTotal =
      sceneOpeningLoadStatus.loadTotal +
      sceneAchievementLoadStatus.loadTotal +
      scenePlayLoadStatus.loadTotal;

    return {
      loaded: loaded,
      loadTotal: loadTotal
    };
  }

  onSceneLoadComplete() {
    this.sceneLoaded++;
    if (this.sceneLoaded === this.sceneLoadMax) this.sceneLoadComplete();
  }

  //------------------------------------
  // change scene
  //------------------------------------
  sceneChange(sceneName) {
    switch (sceneName) {
      case "opening":
        this.sceneOpening.changeStatus(true);
        this.sceneAchievement.changeStatus(false);
        this.scenePlay.changeStatus(false);
        break;
      case "achievement":
        this.sceneOpening.changeStatus(false);
        this.sceneAchievement.changeStatus(true);
        this.scenePlay.changeStatus(false);
        break;
      case "play":
        this.scenePlay.changeMember(this.member);
        this.scenePlay.changeDistance(this.distance);
        this.scenePlay.dateUpdate(new Date());

        this.sceneOpening.changeStatus(false);
        this.sceneAchievement.changeStatus(false);
        this.scenePlay.changeStatus(true);
        break;
    }
  }

  sceneStop() {
    this.sceneOpening.changeStatus(false);
    this.sceneAchievement.changeStatus(false);
    this.scenePlay.changeStatus(false);
  }

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //
  // Scene Opening Control
  //
  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  sceneOpening_changeStep(step) {
    this.sceneOpening.changeStep(step);
  }

  sceneOpening_changePurpose(purpose) {
    this.purpose = purpose;
  }

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //
  // Scene Achievement Control
  //
  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //------------------------------------
  // Step Control
  //------------------------------------
  sceneAchievement_changeStep(step) {
    this.sceneAchievement.changeStep(step);
  }

  async sceneAchievement_searchMap(query) {
    let searchUrl = "https://nominatim.openstreetmap.org/search?q=";
    let option = "&format=xml&addressdetails=1";

    let rawData = await axios.get(encodeURI(searchUrl + query + option));

    const json = xmlToJSON.parseString(rawData.data);

    if (json.searchresults && json.searchresults.length > 0) {
      if (
        json.searchresults[0].place &&
        json.searchresults[0].place.length > 0
      ) {
        console.log(json.searchresults[0].place);
        return json.searchresults[0].place;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async sceneAchievement_loadMap(lat, lon) {
    await this.sceneAchievement.loadMap(lat, lon);
  }

  sceneAchievement_resetMap() {
    this.sceneAchievement.resetMap();
  }

  sceneAchievement_changeMember(member) {
    this.sceneAchievement.changeMember(member);
    this.member = member;
  }

  sceneAchievement_changeDate(date) {
    this.sceneAchievement.changeDate(date);
    this.date = date;
  }

  sceneAchievement_changeDistance(distance) {
    this.sceneAchievement.changeDistance(distance);
    this.distance = distance;
  }

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //
  // Scene Play Control
  //
  //++++++++++++++++++++++++++++++++++++++++++++++++++++++
  scenePlay_changeStep(step) {
    this.scenePlay.changeStep(step);
  }

  scenePlay_charge(per) {
    this.scenePlay.charge(per);
  }

  scenePlay_dateUpdate(date) {
    this.scenePlay.dateUpdate(date);
  }

  scenePlay_boost(result, power) {
    this.scenePlay.boost(result, power);
  }

  scenePlay_screenshot(func) {
    this.scenePlay.screenshot(func);
  }

  //------------------------------------
  // Getter
  //------------------------------------
  getPurpose() {
    return this.purpose;
  }

  getMember() {
    return this.member;
  }

  getDate() {
    return this.date;
  }

  getDistance() {
    return this.distance;
  }

  //------------------------------------
  // Canvas Control
  //------------------------------------
  resize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }
}
export default new GameMain();
